import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  lockedButton: {
    backgroundColor: theme.palette.common.white,
    paddingTop: 2,
    paddingBottom: 2,
    paddingRight: 6,
    borderRadius: 30,
  },
  lockedIcon: {
    marginRight: 0,
    color: theme.palette.common.black,
  },
}));
